import { useSelector } from "react-redux";
import { ICustomerProfileClientState } from "@telstra-connect/token/state";
import {
    ISignInState,
    IUserManagementClientState,
} from "@telstra-connect/login/state";
import { UserType } from '@telstra-connect/utils/data/platform-data'

export default function useCustomerTypeCidn() {
    const customerType = useSelector(
        (state: ICustomerProfileClientState) =>
            state?.tokens?.customerProfile?.data?.profile
    );
    // Retrieve the user's company ID (cidn) from the sign-in state
    const customerCidn: string = useSelector(
        (state: ISignInState) => state?.user?.oauth?.profile?.companyId
    );
    // Retrieve the staff user's company ID (cidn)
    const staffCidn: string = useSelector(
        (state: IUserManagementClientState) =>
            state?.userManagement?.preferences?.data?.lastSelectedCompanies[0].cidn
    );

    return {
        userCidn: customerType === UserType.staffUser ? staffCidn : customerCidn,
    };
};
